import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";

const css = require('./brukerSelect.scss');


/**
 * Nedtrekksmeny for valg av gruppbrukere
 */
    export class BrukerSelect implements IController {

        static registrerKomponent(angular: IModule) {
            angular
                .component('wkBrukerSelect', {
                    bindings: {
                        valgteBrukere: "=",
                        brukere: "<",
                        label: "@",
                        visKunAvatar: "@",
                        visIkon: "@",
                        inputContainerClass: "@"
                    },
                    controller: BrukerSelect.forInjisering(),
                    template: require('./brukerSelect.html'),
                    transclude: true
                })
        }

        static forInjisering() {
            return [regNavn.ng.$attrs, BrukerSelect]
        }

        constructor(private $attrs:IAttributes) {
            //kan ikke bruker bindings på disse da deres verdi ikke er tilgjengelig før
            //md-select rendrer - noe som fører til muliple md-select inne i md-input-container
            //hvorpå angular-material skriker
            this.multiple = this.$attrs['multiple'] === 'true';
            this.required = this.$attrs['required'] === 'true';
        }

        valgteBrukere; //settes via bindings/$onChanges
        brukere:l.EnkelBrukerModell[]; //settes via bindings/$onChanges
        label:string; //settes via bindings/$onChanges
        visKunAvatar = "false"; //settes via bindings
        visIkon = "false"; //settes via bindings
        inputContainerClass = ""; //settes via bindings

        multiple:boolean;
        required:boolean;


        $onChanges(changes: IOnChangesObject) {
            if (changes['valgteBrukere'])
                this.valgteBrukere = changes['valgteBrukere'].currentValue;
            if (changes['brukere'])
                this.brukere = changes['brukere'].currentValue;
        }

    }
